// URL do evento de 30 minutos no Cal.com. Ponto único: o CTA do header, do
// hero, do fecho da home, da página de contato e da hiring leem daqui, e
// trocar o endereço é trocar esta linha.
//
// Se o valor voltar a ser null, o botão cai para /contact, que tem e-mail e
// WhatsApp — o clique continua levando a algum lugar útil.
export const BOOKING_URL = 'https://cal.com/josenaldo/30min'
